const projects = [
  {
    id: 1,
    title: "Aprelevka, Moscow 2023",
    title_item: "Design Project - Aprelevka",
    description:
      "This two-story home embodies a seamless blend of modern minimalism and classic elegance.\n" +
      "The interiors are defined by soft neutral tones, warm textures, and a meticulous attention to detail.\n" +
      "Every space exudes a sense of tranquility and sophistication, with clean lines, subtle contrasts, and luxurious finishes. Linear paneling, herringbone flooring, and carefully curated decor elements such as sculptural lighting fixtures and abstract artwork create a cohesive and timeless aesthetic.\n" +
      "The interplay of natural light and sheer fabrics enhances the airy ambiance, while the use of high-quality materials ensures both comfort and style. This design unites functionality and beauty, offering a refined yet inviting atmosphere throughout the home.\n" +
      "The visualization of the project was created using 3D Max, Corona Render, and Photoshop.\n",
    Location: "Location: Moscow",
    Area: "Area: 390qm\n",
    Year: "Year: 2023",
    video: "/video/project_1_list.mp4",
    images: [
      "/images/Project_1/project_0_item.jpg",
      "/images/Project_1/project_1_list.jpg",
      "/images/Project_1/project_2_item.jpg",
      "/images/Project_1/project_3_item.jpg",
      "/images/Project_1/project_4_item.jpg",
      "/images/Project_1/project_5_item.jpg",
      "/images/Project_1/project_6_item.jpg",
      "/images/Project_1/project_7_item.jpg",
      "/images/Project_1/project_8_item.jpg",
      "/images/Project_1/project_9_item.jpg",
      "/images/Project_1/project_10_item.jpg",
      "/images/Project_1/project_11_item.jpg",
      "/images/Project_1/project_12_item.jpg",
      "/images/Project_1/project_13_item.jpg",
      "/images/Project_1/project_14_item.jpg",
      "/images/Project_1/project_15_item.jpg",
      "/images/Project_1/project_16_item.jpg",
      "/images/Project_1/project_17_item.jpg",
    ],
    categoryId: 1,
  },
  {
    id: 2,
    title: "Moscow (Lansen Park) 2024",
    title_item: "Design Project - Lansen Park",
    description:
      "A two-story timber house located in Moscow with an area of 380 sq. meters.\n" +
      "The interior is designed in a modern Scandinavian style with elements of eco-minimalism, combining natural materials, light tones, and clean lines. \n" +
      "The space emphasizes natural lighting, comfort, and sustainability. \n" +
      "The design was developed in collaboration with the project architect. \n" +
      "Visualization was created using 3ds Max, Corona Renderer, and Adobe Photoshop.\n",

    Location: "Location: Moscow (Lansen Park)",
    Area: "Area: 380qm\n",
    Year: "Year: 2024",
    video: "/video/project_2_list.mp4",
    images: [
      "/images/Project_2/project_0_item.jpg",
      "/images/Project_2/project_1_item.jpg",
      "/images/Project_2/project_2_item.jpg",
      "/images/Project_2/project_3_item.jpg",
      "/images/Project_2/project_4_item.jpg",
      "/images/Project_2/project_5_item.jpg",
      "/images/Project_2/project_6_item.jpg",
      "/images/Project_2/project_7_item.jpg",
      "/images/Project_2/project_8_item.jpg",
      "/images/Project_2/project_9_item.jpg",
      "/images/Project_2/project_10_item.jpg",
      "/images/Project_2/project_11_item.jpg",
      "/images/Project_2/project_12_item.jpg",
      "/images/Project_2/project_13_item.jpg",
      "/images/Project_2/project_14_item.jpg",
      "/images/Project_2/project_15_item.jpg",
      "/images/Project_2/project_16_item.jpg",
      "/images/Project_2/project_17_item.jpg",
      "/images/Project_2/project_18_item.jpg",
      "/images/Project_2/project_19_item.jpg",
      "/images/Project_2/project_20_item.jpg",
      "/images/Project_2/project_21_item.jpg",
    ],
    categoryId: 2,
  },
  {
    id: 3,
    title: "B. A. Moscow 2023",
    title_item: "Design Project - B. A.",
    description:
      "Elegant interior in a modern classic style. It is a joint work with the architect of the project, on the design and visualization of the interiors, selection of furniture and finishing materials.\n" +
      "Our images bring the details of this space to life: pastel shades, warm colors and subtle colors create an atmosphere of calm and cosiness. Moldings on the ceiling and walls, angled herringbone parquet flooring and contrasting elements add to the elegance of the interior.\n" +
      "Each room is imbued with attention to detail and conveys a distinctive interior atmosphere.\n" +
      "The visualization of the project was created using 3D Max, Corona Render, and Photoshop.\n",
    Location: "Location: Moscow",
    Area: "Area: 78.9qm\n",
    Year: "Year: 2023",
    video: "/video/project_3_list.mp4",
    images: [
      "/images/Project_3/project_0_item.jpg",
      "/images/Project_3/project_1_list.jpg",
      "/images/Project_3/project_2_item.jpg",
      "/images/Project_3/project_3_item.jpg",
      "/images/Project_3/project_4_item.jpg",
      "/images/Project_3/project_5_item.jpg",
      "/images/Project_3/project_6_item.jpg",
      "/images/Project_3/project_7_item.jpg",
      "/images/Project_3/project_8_item.jpg",
    ],
    categoryId: 3,
  },
  {
    id: 4,
    title: "Dukhanino-2 Moscow region 2023",
    title_item: "Design Project - O.",
    description:
      "Welcome to the wooden house in Dukhanino, surrounded by fir and pine trees, a true harmony with nature. This interior uses eco-friendly materials, creating an atmosphere of naturalness and cosiness.\n" +
      "The interior is decorated with warm pastel tones, including grassy, beige and red tones. The walls are finished in wood, which gives the room a natural and organic look. The furniture is predominantly in shades of reddish and beige, creating a harmonious combination with the natural surroundings.\n" +
      "Modern interiors weave stylish furniture and bright herbaceous accents, such as plants, paintings and carpets, with reddish and beige colours present in the leather of the furniture and the wood. In this large room, the focal point is the kitchen island, next to which are the kitchen and dining area with a spacious table for 8-10 people. There is also a cosy seating area with a large comfortable sofa and a TV.\n" +
      "The windows are decorated with elaborate curtains, custom-made in beige and grass green material. They give the interior an extra touch of elegance and pleasant light. The wall of windows creates a link between nature and cosiness in the room, allowing you to enjoy the beautiful view of the spruce trees even during the colder seasons.\n" +
      "This is an interior where nature meets warmth and comfort, while modern style and stylish furniture add a touch of elegance.",
    Location: "Location: Moscow region",
    Area: "Area: 80.4qm\n",
    Year: "Year: 2023",
    video: "/video/project_4_list.mp4",
    images: [
      "/images/Project_4/project_0_item.jpg",
      "/images/Project_4/project_1_item.jpg",
      "/images/Project_4/project_2_item.jpg",
      "/images/Project_4/project_3_item.jpg",
      "/images/Project_4/project_4_item.jpg",
      "/images/Project_4/project_5_item.jpg",
      "/images/Project_4/project_2_list.jpg",
      "/images/Project_4/project_7_item.jpg",
      "/images/Project_4/project_8_item.jpg",
      "/images/Project_4/project_9_item.jpg",
      "/images/Project_4/project_10_item.jpg",
    ],

    categoryId: 4,
  },
  {
    id: 5,
    title: "Flat No. 46 Moscow 2021",
    title_item: "Design Project - Flat No. 46",
    description:
      "Welcome to a stylish and bright one-bedroom flat, which despite its modest 60 square metres, creates a feeling of spaciousness, lightness and elegance. White paintings in relief, combined with lighting, play an important role in shaping the texture of the interior. Grey and purple pastel accents add lightness and sophistication.\n" +
      "Smooth and glossy surfaces of walls, doors and furniture create an airy impression and add modernity to the interior. The rooms are light and airy, with the effective use of natural and artificial light to highlight the benefits of every corner.\n" +
      "The living room is combined with the kitchen, and the flat also has a bedroom, cloakroom and two bathrooms. This design is ideal for a couple who are at the start of their life journey and are not yet thinking about maximum comfort. Every detail has been thought out to create a stylish and functional space for comfortable living.\n" +
      "We invite you to appreciate this cosy and elegant flat, where light, space and style combine in harmony to create the perfect place to embark on new adventures.\n",
    Location: "Location: Moscow",
    Area: "Area: 60.7qm\n",
    Year: "Year: 2021",
    video: "/video/project_5_list.mp4",
    images: [
      "/images/Project_5/project_3_list.jpg",
      "/images/Project_5/project_1_item.jpg",
      "/images/Project_5/project_2_item.jpg",
      "/images/Project_5/project_3_item.jpg",
      "/images/Project_5/project_4_item.jpg",
      "/images/Project_5/project_5_item.jpg",
      "/images/Project_5/project_6_item.jpg",
      "/images/Project_5/project_7_item.jpg",
    ],
    categoryId: 5,
  },
  {
    id: 6,
    title: "Flat No. 39 Moscow 2021",
    title_item: "Design Project - Flat No. 39",
    description:
      "Welcome to a flat that is spacious and deep in tone. The main rooms are divided by functional and decorative partitions that divide the space between the kitchen-dining room and the living room. The kitchen has a rounded corner, adding a certain cosiness and visibility to the outside space. There is also a spacious balcony stretching the length of the living room.\n" +
      "\n" +
      "A special feature of this interior is the unusual combination of textures, shapes, straight lines and shades. Black marble with an unexpected contrasting pattern and glossy orange panels on the entire corridor wall create a unique visual effect, dominating the entire space. And even the ceiling, in dark green with a large white and blue pattern, combined with the lighting, gives the interior balance, character and a special atmosphere.\n" +
      "The overall interior is dominated by dark tones, but the gloss and contrasting reflections add spatial depth and tranquillity, despite the bright spots.\n" +
      "\n" +
      "In the living room there is a glass decorative wall, which divides the hallway space and creates spatial depth to the scenery on stage.\n" +
      "And creates a parallel pathway leading to the bedroom.  The lounge combines the functions of an office and a living room, providing space to work and relax.\n" +
      "\n" +
      "Additionally, this interior features two stylish high-tech bathrooms, one in white and the other in darker shades.\n" +
      "\n" +
      "The dark tone of the bedrooms and the bedroom trim creates a cosy atmosphere for a restful sleep or for unwinding after a long day.\n" +
      "We invite you to take the plunge into this unique interior, where a combination of different textures, colours and contrasts creates an elegant and contemporary atmosphere.\n",
    Location: "Location: Moscow",
    Area: "Area: 166.77qm\n",
    Year: "Year: 2021",
    video: "/video/project_6_list.mp4",
    images: [
      "/images/Project_6/project_0_item.jpg",
      "/images/Project_6/project_4_list.jpg",
      "/images/Project_6/project_2_item.jpg",
      "/images/Project_6/project_3_item.jpg",
      "/images/Project_6/project_4_item.jpg",
      "/images/Project_6/project_5_item.jpg",
      "/images/Project_6/project_6_item.jpg",
      "/images/Project_6/project_7_item.jpg",
      "/images/Project_6/project_8_item.jpg",
    ],

    categoryId: 6,
  },
  {
    id: 7,
    title: "Flat No. 45 Moscow 2021",
    title_item: "Design Project - Flat No. 45",

    description:
      "Welcome to a unique and stylish interior, where every detail has been conceived down to the smallest detail. You are greeted by a spacious and warm entrance hall, where light wood paneling harmonizes with floor-to-ceiling glass doors.\n" +
      "The living room and kitchen are separated by sliding glass doors, which can unite the two spaces or create an intimate setting of your own choosing. The bathrooms, finished in white marble, contrast wonderfully with the dark fittings and stylish fixtures, creating a dramatic aesthetic contrast.\n" +
      "The bedrooms, decorated with plaster panels with unique patterns, blend perfectly with the voluminous furniture, creating an internal dialogue and interaction between them, like a bridge between art and comfort.\n" +
      "In this interior, glossy panels, glass, and pastel velvet furniture are harmoniously combined to create an interesting balance between modernity and coziness. Each room intertwines with the other, creating a unique symphony of styles and emotions.\n" +
      "Immerse yourself in this intriguing and elegant interior, where a unique combination of materials and design solutions create a unique atmosphere in which every moment is special.\n",
    Location: "Location: Moscow",
    Area: "Area: 120.8qm\n",
    Year: "Year: 2021",
    video: "/video/project_7_list.mp4",
    images: [
      "/images/Project_7/project_5_list.jpg",
      "/images/Project_7/project_1_item.jpg",
      "/images/Project_7/project_2_item.jpg",
      "/images/Project_7/project_3_item.jpg",
      "/images/Project_7/project_4_item.jpg",
      "/images/Project_7/project_5_item.jpg",
      "/images/Project_7/project_6_item.jpg",
      "/images/Project_7/project_7_item.jpg",
    ],

    categoryId: 7,
  },
  {
    id: 8,
    title: "Home design project, Moscow region,  Rastorguevo 2020",
    title_item: "Home design project -  Rastorguevo",
    description: `Welcome to this unusual and fun interior, where the house has been renovated and redesigned, and a unique design project has been created. This spacious house of almost 600 square metres includes a basement with sauna and gym, two living floors and an attic floor with cinema and billiard room.

    The result is a cosy, modern and family-oriented interior. It has a somewhat eclectic style, combining elements of modern classics with plinths and mouldings on the walls, oriental inserts in the form of carved columns from Samarkand (Uzbekistan) and stylish high-tech.

    Each room has its own character and creates a specific mood. The dining room, for example, is designed for family gatherings and can accommodate a very large family. It has a seating area right on the windowsills, adding to the cosiness and comfort.

    In the stairwell, you'll be greeted by a carved column that recalls the courtyard of a 'caravanserai'. Tiles, paintings, colour schemes and furniture in the interior give it a sunny warmth and oriental cosiness. On the attic floor, for example, you'll find low sofas reminiscent of oriental (couch) 'tapchan'.

    Special attention has been given to creating light and gentle children's rooms for the three daughters. They have become the perfect place to play and relax, reflecting the individuality of each of the girls.

    We invite you to take the plunge into this unique interior, where different styles are reunited and comfort and joy is created for the whole family.`,
    Location: "Location: Moscow region,  Rastorguevo",
    Area: "Area: 598,7qm",
    Year: "Year: 2020",
    video: "/video/project_8_list.mp4",
    images: [
      "/images/Project_8/project_6_list.jpg",
      "/images/Project_8/project_1_item.jpg",
      "/images/Project_8/project_2_item.jpg",
      "/images/Project_8/project_3_item.jpg",
      "/images/Project_8/project_4_item.jpg",
      "/images/Project_8/project_5_item.jpg",
      "/images/Project_8/project_6_item.jpg",
      "/images/Project_8/project_7_item.jpg",
      "/images/Project_8/project_8_item.jpg",
      "/images/Project_8/project_9_item.jpg",
      "/images/Project_8/project_10_item.jpg",
      "/images/Project_8/project_11_item.jpg",
      "/images/Project_8/project_12_item.jpg",
    ],

    categoryId: 8,
  },
  {
    id: 9,
    title: "Design project laminated timber house, Moscow region, 2020",
    title_item: "Home design project -  R. E.",
    description: `We present a sophisticated and stylish design for a two-storey laminated timber house, combining redwood (walnut) with copper panelling and deep green. Light black threads of light fixtures, like spider-like accents, flow through the double-height space, imbuing the house with graphics and light. The second light, enclosed by a glass railing, creates a sense of overview and cosiness, where you can sit in an armchair and read a book.

    Large format graphic pictures compliment the interior despite their imposing size, as elements of continuity in the lighting, furniture, and textures. They give rooms extra aesthetic accent and visual interest.

    Every corner of the house shows style and good taste. The combination of sustainable materials and modern design elements creates a special harmony, which gives the interior a cosy and elegant feel. Every detail and the chosen materials contribute to the beautiful look and feel of this home.`,
    Location: "Location: Moscow region",
    Area: "Area: 426,64qm",
    Year: "Year: 2020",
    video: "/video/project_9_list.mp4",
    images: [
      "/images/Project_9/project_7_list.jpg",
      "/images/Project_9/project_1_item.jpg",
      "/images/Project_9/project_2_item.jpg",
      "/images/Project_9/project_3_item.jpg",
      "/images/Project_9/project_4_item.jpg",
      "/images/Project_9/project_5_item.jpg",
      "/images/Project_9/project_6_item.jpg",
      "/images/Project_9/project_7_item.jpg",
      "/images/Project_9/project_8_item.jpg",
      "/images/Project_9/project_9_item.jpg",
      "/images/Project_9/project_10_item.jpg",
      "/images/Project_9/project_11_item.jpg",
      "/images/Project_9/project_12_item.jpg",
    ],

    categoryId: 9,
  },
  {
    id: 10,
    title: "Design and implementation of a flat, Moscow, 2013",
    title_item: "Design and implementation of a flat -  V.D.",
    description: `Introducing you to one of my favourite jobs as part of IND architects. This project was special and required a special approach, as the client had his own unique preferences. In the end the project was successfully implemented, despite not being a complete match to the design, the project turned out great. One of the special features of this project were the paintings that were specially commissioned by the well-known artist Oleg Morozov.

    The flat is located in the centre of Moscow and has a spacious view from the window. It has achieved elegance of style, where gold elements, some luxury and cosiness are perfectly combined. This flat is designed for a young and attractive couple who appreciate beauty and unique design.
    
    The whole project reflects a dedication to quality and detail, and is a great example of working together. I am proud of this project and hope it will be a source of inspiration for future works.`,
    Location: "Location: Moscow",
    Area: "Area: 178,35qm",
    Year: "Year: 2013",
    video: "/video/project_10_list.mp4",
    images: [
      "/images/Project_10/project_8_list.jpg",
      "/images/Project_10/project_2_item.jpg",
      "/images/Project_10/project_3_item.jpg",
      "/images/Project_10/project_4_item.jpg",
      "/images/Project_10/project_5_item.jpg",
      "/images/Project_10/project_6_item.jpg",
      "/images/Project_10/project_7_item.jpg",
      "/images/Project_10/project_8_item.jpg",
      "/images/Project_10/project_9_item.jpg",
      "/images/Project_10/project_10_item.jpg",
      "/images/Project_10/project_11_item.jpg",
      "/images/Project_10/project_12_item.jpg",
      "/images/Project_10/project_13_item.jpg",
      "/images/Project_10/project_14_item.jpg",
    ],

    categoryId: 10,
  },
  {
    id: 11,
    title: "Restaurant and café design, Sochi, 2012",
    title_item: "Restaurant and café design",
    description:
      "One of my favourite projects, which unfortunately did not come to fruition due to a lack of will or desire on the part of the client.\n" +
      "\n" +
      "This project is a restaurant and cafe, in the city of Sochi, located on three levels in a shopping centre. The ground floor and the terrace are intended as a cafe and the first floor has 2 levels for the restaurant.\n" +
      "\n" +
      "Particular attention has been paid to the position of the kitchen, which is behind glass in the centre, in the back. Blue tiles with Asian ornaments in the kitchen are a striking colour accent. This space becomes the main place where magic is made. All guests are accessible and visible. The restaurant has an open, curved balcony where tables are placed for diners.\n" +
      "\n" +
      "The warm ochre colours of the furniture, the decoration, the ornaments and the lighting create a cosy and warm atmosphere of Asian cosiness. Every detail in the interior is carefully designed to create a unique atmosphere and satisfy the taste of each guest.\n" +
      "\n" +
      "It is a shame that this project was not fully realised, but I hope it can serve as inspiration for future projects and an insight into what a beautiful space can be created for the restaurant business.\n",
    Location: "Location: Sochi",
    Area: "Area: 3 floors + terrace\n",
    Year: "Year: 2012",
    video: "/video/project_11_list.mp4",
    images: [
      "/images/Project_11/project_1_item.jpg",
      "/images/Project_11/project_9_list.jpg",
      "/images/Project_11/project_3_item.jpg",
      "/images/Project_11/project_4_item.jpg",
      "/images/Project_11/project_5_item.jpg",
      "/images/Project_11/project_6_item.jpg",
      "/images/Project_11/project_7_item.jpg",
      "/images/Project_11/project_8_item.jpg",
      "/images/Project_11/project_9_item.jpg",
    ],

    categoryId: 11,
  },
  {
    id: 12,
    title: "Restaurant design, Almaty, Kazakhstan, 2011",
    title_item: "Restaurant design",
    description: `Also one of my interesting projects is a restaurant and banqueting hall full of decor and oriental luxury. 

      The restaurant, on level 2, is a modern, futuristic space where modern lines and materials are combined with elements of oriental culture. The use of LED lighting, textured surfaces and flexible forms creates a feeling of the future and a magical atmosphere.
      
      The second room, on the 3rd level, is a banqueting hall, designed for weddings and celebrations. It is distinguished by a sumptuous and ornate decoration, where oriental patterns, golden hues and an abundance of precious materials create an atmosphere of splendour and opulence. Every detail, from embroidered textiles to crystal chandeliers, contributes to the ambience of an oriental palace.
      
      Even the corridors and lifts in the restaurant are filled with decorative elements and oriental patterns on the walls. They bring visitors the feeling that they have entered an oriental fairy tale, where every step reminds them of the wealth and luxury of the ancient East.
      
      It was a fascinating job where our imagination and creative will prevailed, allowing us to create a space that transports guests into a world of oriental exoticism and luxury.`,
    Area: "Area: 2 floors",
    Year: "Year: 2011",
    video: "/video/project_12_list.mp4",
    images: [
      "/images/Project_12/project_10_list.jpg",
      "/images/Project_12/project_2_item.jpg",
      "/images/Project_12/project_3_item.jpg",
      "/images/Project_12/project_4_item.jpg",
      "/images/Project_12/project_5_item.jpg",
      "/images/Project_12/project_6_item.jpg",
      "/images/Project_12/project_7_item.jpg",
    ],

    categoryId: 12,
  },
  {
    id: 13,
    title: "Flat de S. Moscow 2023",
    title_item: "Flat design",
    description: `A small apartment for rent. So the task was to make it stylish, tasteful and not very expensive. In my opinion, the architect and I found the golden mean.`,
    Area: "Area: 46,06qm",
    Year: "Year: 2023",
    // image: "/images/Project_14/project_14_1.jpg",
    video: "/video/project_13_list.mp4",
    images: [
      "/images/Project_13/project_13_1.jpg",
      "/images/Project_13/project_13_2.jpg",
      "/images/Project_13/project_13_3.jpg",
      "/images/Project_13/project_13_4.jpg",
      "/images/Project_13/project_13_5.jpg",
      "/images/Project_13/project_13_6.jpg",
      "/images/Project_13/project_13_7.jpg",
    ],

    categoryId: 13,
  },
  {
    id: 14,
    title: "A Guest House with a Sauna/Spa Complex, Moscow 2025",
    title_item: "A Guest House",
    description: `Our goal was to create a masculine retreat with a spa, a billiards room, and a study. We believe we've found the perfect balance of brutal charm and modern comfort.`,
    Area: "Area: 224,4qm",
    Year: "Year: 2025",
    // video: "/video/project_13_list.mp4",
    image: "/images/Project_14/project_14_1.jpg",
    images: [
      "/images/Project_14/project_14_1.jpg",
      "/images/Project_14/project_14_2.jpg",
      "/images/Project_14/project_14_3.jpg",
      "/images/Project_14/project_14_4.jpg",
      "/images/Project_14/project_14_5.jpg",
      "/images/Project_14/project_14_6.jpg",
      "/images/Project_14/project_14_7.jpg",
      "/images/Project_14/project_14_8.jpg",
      "/images/Project_14/project_14_9.jpg",
    ],

    categoryId: 14,
  },
  {
    id: 15,
    title: "A Guest House with a Sauna/Spa Complex, Moscow 2025",
    title_item: "A Guest House",
    description: `Our goal was to create a cozy countryside retreat—a cottage with a spa zone for complete relaxation. We found the perfect balance between rustic charm and modern comfort.`,
    Area: "Area: 167,5qm",
    Year: "Year: 2025",
    // video: "/video/project_13_list.mp4",
    image: "/images/Project_15/project_15_1.jpg",
    images: [
      "/images/Project_15/project_15_1.jpg",
      "/images/Project_15/project_15_2.jpg",
      "/images/Project_15/project_15_3.jpg",
    ],

    categoryId: 15,
  },
  {
    id: 16,
    title: "A Selection of Interior Design Projects, Moscow - Deutschland",
    title_item: "Interior Design Projects",
    description: `A selection of projects from different periods — from spacious apartments to compact studios.`,
    Area: "Area: -",
    Year: "Year: 2020-2025",
    // video: "/video/project_13_list.mp4",
    image: "/images/Project_16/project_16_1.jpg",
    images: [
      "/images/Project_16/project_16_1.jpg",
      "/images/Project_16/project_16_2.jpg",
      "/images/Project_16/project_16_2_2.jpg",
      "/images/Project_16/project_16_3.jpg",
      "/images/Project_16/project_16_4.jpg",
      "/images/Project_16/project_16_5.jpg",
      "/images/Project_16/project_16_6.jpg",
      "/images/Project_16/project_16_7.jpg",
      "/images/Project_16/project_16_8.jpg",
      "/images/Project_16/project_16_9.jpg",
      "/images/Project_16/project_16_10.jpg",
      "/images/Project_16/project_16_11.jpg",
    ],

    categoryId: 16,
  },
];

export default projects;
